import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../layout/index'
import organizationRouters from './modules/organization'
import laborOutsourcingRouters from './modules/laborOutsourcing'
import attendanceRouters from './modules/attendance'
import memberRouters from './modules/member'
import salaryPayDirectRouters from './modules/salaryPayDirect'
import projectRouters from './modules/project'
import taskRouters from './modules/task'
import marketRoutes from './modules/market'
import salaryManageRouters from './modules/salaryManage'
Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/login',
    meta: { title: '登录', noCache: true },
    component: () => import('@/views/login'),
    hidden: true
  },
  {
    path: '/forget',
    meta: { title: '忘记密码', noCache: true },
    component: () => import('@/views/forget'),
    hidden: true
  },
  {
    path: '/regist',
    meta: { title: '注册', noCache: true },
    component: () => import('@/views/regist'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/features/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/features/401'),
    hidden: true
  },
  {
    path: '/alipay',
    component: () => import('@/views/alipay'),
    hidden: true
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/features/redirect')
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard'),
        name: 'Dashboard',
        meta: { title: '首页', icon: 'home', affix: true, noCache: true, id: '1565269707165024258' },
        hidden: true,
      },
      {
        path: 'importBatch',
        component: () => import('@/views/person/personList/importBatch'),
        name: 'ImportBatch',
        meta: { title: '批量导入', icon: 'a-up', noCache: false },
        hidden: true
      },
      {
        path: 'importIdcard',
        component: () => import('@/views/person/personList/importIdcard'),
        name: 'importIdcard',
        meta: { title: '上传证照', icon: 'a-up', noCache: false },
        hidden: true
      },
      {
        path: 'importRecord',
        component: () => import('@/views/person/personList/importRecord'),
        name: 'importRecord',
        meta: { title: '导入记录', icon: 'a-up', noCache: false },
        hidden: true
      },
      {
        path: 'importDetail',
        component: () => import('@/views/person/personList/importDetail'),
        name: 'importDetail',
        meta: { title: '导入详情', icon: 'a-up', noCache: false },
        hidden: true
      },
      {
        path: 'importImgDetail',
        component: () => import('@/views/person/personList/importIdcard'),
        name: 'importImgDetail',
        meta: { title: '证照导入详情', icon: 'a-up', noCache: false },
        hidden: true
      },
      {
        path: 'invoiceApply',
        component: () => import('@/views/invoice/entrusted/apply'),
        name: 'invoiceApply',
        meta: { title: '开票申请', icon: 'a-up', noCache: false },
        hidden: true
      },
      {
        path: 'taskDetail',
        component: () => import('@/views/project/taskManage/taskDetail'),
        name: 'taskDetail',
        meta: { title: '任务详情', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: 'preApply',
        component: () => import('@/views/invoice/pre/apply'),
        name: 'preApply',
        meta: { title: '预开票申请', icon: 'a-up', noCache: false },
        hidden: true
      },
      {
        path: 'preApplyList',
        component: () => import('@/views/invoice/pre/applyList'),
        name: 'preApplyList',
        meta: { title: '预开票申请列表', icon: 'a-up', noCache: false },
        hidden: true
      },
      {
        path: '/invoice/pre/payment',
        component: () => import('@/views/invoice/pre/payment'),
        name: 'preApplyList',
        meta: { title: '预开订单付款', icon: 'a-up', noCache: false },
        hidden: true
      },
      {
        path: 'spdBankWithdrawPage',
        component: () => import('@/views/transaction/withdraw/spdBank'),
        name: 'spdBankWithdrawPage',
        meta: { title: '提现(浦发银行)', icon: 'a-up', noCache: false },
        hidden: true
      },
      {
        path: 'alipayWithdrawPage',
        component: () => import('@/views/transaction/withdraw/aliPay'),
        name: 'alipayWithdrawPage',
        meta: { title: '提现(支付宝)', icon: 'a-up', noCache: false },
        hidden: true
      },
      {
        path: 'cmbWithdrawPage',
        component: () => import('@/views/transaction/withdraw/cmb'),
        name: 'cmbWithdrawPage',
        meta: { title: '提现(招商银行)', icon: 'a-up', noCache: false },
        hidden: true
      },
      {
        path: 'BlackListImport',
        component: () => import('@/views/risk/blackList/importBatch'),
        name: 'BlackListImport',
        meta: { title: '批量导入黑名单', icon: 'a-up', noCache: false },
        hidden: true
      },
      {
        path: 'selfApplyRecord',
        component: () => import('@/views/person/selfEmployedApplyList'),
        name: 'selfApplyRecord',
        meta: { title: '个体户申请记录', icon: 'a-up', noCache: false },
        hidden: true
      },
      {
        path: 'payDetail',
        component: () => import('@/views/order/initial/payDetail'),
        name: 'payDetail',
        meta: { title: '批次明细', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        // 项目选择已上提到付款页容器，独立入口统一落到容器 tab 页（文件付款）
        path: 'commissionsFilePayment',
        component: () => import('@/views/transaction/commissions/index'),
        name: 'commissionsFilePayment',
        meta: { title: '付款', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: 'commissionsBatchPayment',
        component: () => import('@/views/transaction/commissions/batchPayment'),
        name: 'commissionsBatchPayment',
        meta: { title: '付款确认', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        // 独立入口统一落到容器 tab 页（页面付款）
        path: 'commissionsProjectPayment',
        component: () => import('@/views/transaction/commissions/index'),
        name: 'projectPayment',
        meta: { title: '页面付款', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        // 任务结算独立入口：直接进入验收付款页，支持 query 带入项目/验收记录
        path: 'commissionsAcceptancePayment',
        component: () => import('@/views/transaction/commissions/acceptancePayment'),
        name: 'acceptancePayment',
        meta: { title: '验收记录付款', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: 'tempTaxRegistRecord',
        component: () => import('@/views/person/tempTaxRegist/record'),
        name: 'tempTaxRegistRecord',
        meta: { title: '临登记录', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: 'lessorList/importBatch',
        component: () => import('@/views/lessorManage/lessorList/importBatch'),
        name: 'lessorImportBatch',
        meta: { title: '批量导入', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: 'lessorList/importRecord',
        component: () => import('@/views/lessorManage/lessorList/importRecord'),
        name: 'staffImportRecord',
        meta: { title: '导入记录', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: 'lessorList/importDetail',
        component: () => import('@/views/lessorManage/lessorList/importDetail'),
        name: 'importDetail',
        meta: { title: '导入详情', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: 'carList/importBatch',
        component: () => import('@/views/carManage/carList/importBatch'),
        name: 'carImportBatch',
        meta: { title: '批量导入', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: 'carList/carDetail',
        component: () => import('@/views/carManage/carList/carDetail'),
        name: 'carDetail',
        meta: { title: '车辆详情', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: '/sealInfo',
        component: () => import('@/views/contractManage/sealManage/sealInfo'),
        name: 'sealInfo',
        meta: { title: '添加印章', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: '/clockIn/clockInSet',
        component: () => import('@/views/project/clockIn/clockInSet'),
        name: 'clockInSet',
        meta: { title: '打卡表设置', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: '/financial/transaction/billList/billDetail',
        component: () => import('@/views/transaction/billList/billDetail'),
        name: 'billDetail',
        meta: { title: '清单明细', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: '/messageCenter',
        component: () => import('@/views/system/messageCenter/messageList'),
        name: 'messageList',
        meta: { title: '消息中心', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: '/set/roleSet',
        component: () => import('@/views/set/role/roleSet'),
        name: 'roleSet',
        meta: { title: '新增角色', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: '/soleTrader/manage/:id',
        component: () => import('@/views/soleTrader/soleTraderList/manage'),
        name: 'soleTraderManage',
        meta: { title: '个体户管理', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: '/marketingRebates/rebateInfo',
        component: () => import('@/views/marketingRebates/rebateInfo'),
        name: 'rebateInfo',
        meta: { title: '营销活动信息', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: '/marketingRebates/rebateProject/create',
        component: () => import('@/views/marketingRebates/rebateProject/create'),
        name: 'rebateProjectCreate',
        meta: { title: '创建营销活动', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: '/marketingRebates/rebateProject/edit',
        component: () => import('@/views/marketingRebates/rebateProject/edit'),
        name: 'rebateProjectEdit',
        meta: { title: '编辑营销活动', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: '/marketingRebates/rebateProject/detail',
        component: () => import('@/views/marketingRebates/rebateProject/detail'),
        name: 'rebateProjectDetail',
        meta: { title: '营销活动详情', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: '/productMarket',
        component: () => import('@/views/productMarket/index'),
        name: 'ProductMarket',
        meta: { title: '产品市场', icon: 'a-up', noCache: true },
        hidden: true
      }, {
        path: '/productMarket/detail',
        component: () => import('@/views/productMarket/productDetail'),
        name: 'ProductDetails',
        meta: { title: '产品详情', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: '/hrManage/reports/staffReport/detail',
        component: () => import('@/views/hrManage/reports/staffReport/detail'),
        name: 'StaffReportDetail',
        meta: { title: '人事报表明细', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: '/attendance/audit',
        component: () => import('@/views/attendance/audit/index'),
        name: 'AttendanceAudit',
        meta: { title: '审批列表', icon: 'a-up', noCache: true },
        hidden: true
      },
      {
        path: '/salaryPayDirect/account',
        component: () => import('@/views/salaryPayDirect/openAccount/index'),
        name: 'SalaryPayDirectAccount',
        meta: { title: '授权开户', icon: 'a-up', noCache: true },
        hidden: true
      },
      ...organizationRouters,
      ...laborOutsourcingRouters,
      ...attendanceRouters,
      ...memberRouters,
      ...salaryPayDirectRouters,
      ...projectRouters,
      ...taskRouters,
      ...marketRoutes,
      ...salaryManageRouters
    ]
  },
  {
    path: '/contract/template/config',
    component: () => import('@/views/contractManage/templateManage/config'),
    name: 'templateConfig',
    meta: { title: '合同模板配置' },
    hidden: true
  },
   {
    path: '/templatePreview',
    component: () => import('@/views/contractManage/templateManage/tempPreview'),
    name: 'templatePreview',
    meta: { title: '合同模版预览' },
    hidden: true
  },
  {
    path: '/evidentiary/config',
    component: () => import('@/views/evidentiary/config'),
    name: 'evidentiary',
    meta: { title: '证明模板配置', icon: 'a-up', noCache: true },
    hidden: true
  },
  {
    path: '/entSelfRegister',
    meta: { title: '企业入驻申请', noCache: true },
    component: () => import('@/views/infoCollection/entSelfRegister'),
    hidden: true
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'center',
        component: () => import('@/views/system/user/center'),
        name: '个人中心',
        meta: { title: '个人中心' }
      }
    ]
  },
]

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
